import { matchType } from "../../matcher";
export const DayOfWeekLiteralList = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
];
export class DayOfWeek {
    v;
    constructor(v) {
        this.v = v;
    }
    static of(v) {
        return new DayOfWeek(v);
    }
    static fromNumber(dayOfWeek) {
        switch (dayOfWeek) {
            case 0:
                return DayOfWeek.of("Sunday");
            case 1:
                return DayOfWeek.of("Monday");
            case 2:
                return DayOfWeek.of("Tuesday");
            case 3:
                return DayOfWeek.of("Wednesday");
            case 4:
                return DayOfWeek.of("Thursday");
            case 5:
                return DayOfWeek.of("Friday");
            case 6:
                return DayOfWeek.of("Saturday");
        }
    }
    getNumber() {
        switch (this.v) {
            case "Sunday":
                return 0;
            case "Monday":
                return 1;
            case "Tuesday":
                return 2;
            case "Wednesday":
                return 3;
            case "Thursday":
                return 4;
            case "Friday":
                return 5;
            case "Saturday":
                return 6;
        }
    }
    equals(other) {
        return this.v === other.v;
    }
    static display(dayOfWeekLiteral) {
        const label = matchType(dayOfWeekLiteral, {
            Sunday: "日",
            Monday: "月",
            Tuesday: "火",
            Wednesday: "水",
            Thursday: "木",
            Friday: "金",
            Saturday: "土",
        });
        return label;
    }
}
//# sourceMappingURL=day-of-week.js.map